

"use client";

import React from "react";
import { Box, Container, Typography, Button, Stack, Chip } from "@mui/material";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { IMAGES } from "../constants/images";
import NextLink from "next/link";
const Main = () => {
  const router = useRouter();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <Box
      sx={{
        width: "100%",
        backgroundImage: `url('${IMAGES.BG_MAIN}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: { xs: "flex-start", md: "flex-start" },
            gap: { xs: 2, sm: 3, md: 4 },
            px: { xs: 2, sm: 3, md: 0 },
            pt: { xs: "20%", sm: "20%", md: "15%", lg: "10%", xl: "9%" },
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              flex: 1,
              maxWidth: { xs: "100%", md: "50%" },
              display: "flex",
              flexDirection: "column",
              alignItems: isRTL ? "flex-end" : "flex-start",
              textAlign: isRTL ? "right" : "left",
              "@media (min-width:1100px) and (max-width:1300px)": {
                maxWidth: "45%",
              },
              "@media (min-width:1400px) and (max-width:1535px)": {
                maxWidth: "40%",
              },
            }}
          >
            <Chip
              label={t("hero.chip")}
              sx={{
                alignSelf: isRTL ? "flex-start" : "flex-start",
                backgroundColor: "transparent",
                border: "1px solid #0206174D",
                mb: { xs: isRTL ? 4 : 3, sm: 4 },
                color: "#6c688a",
                fontSize: { xs: "12px", sm: "13px", md: "14px" },
                fontWeight: "500",
                px: { xs: 0.5, sm: 1, md: 0.2 },
                py: { xs: 1.8, sm: 2, md: 2.2 },
                fontFamily: "var(--font-outfit)",
                borderRadius: "40px",
                textTransform: "none",
                mt: { xs: "9%", sm: "7%", md: "7%" },
              }}
            />

            {/* <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  lg: "2.1rem",
                  xl: "3.4rem",
                },
                fontWeight: "700",
                mb: { xs: 0.8, sm: 1, md: 1, lg: 0.5, xl: 1.2 },
                lineHeight: isRTL
                  ? { xs: 1.2, md: 1.3 }
                  : { xs: 1.2, md: 1.15 },
                position: "relative",
                fontFamily: "var(--font-plusjakarta)",
                color: "#000000",
                textAlign: isRTL ? "right" : "left",
                width: "100%",
              }}
            >
              {t("hero.title1")}
              <span style={{ color: "#6D50E0" }}>
                {t("hero.titleHighlight1")}
              </span>
              {t("hero.title2")}
              <span style={{ color: "#6D50E0" }}>
                {t("hero.titleHighlight2")}
              </span>
              {t("hero.title3")}
            </Typography> */}
             <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  lg: "2.1rem",
                  xl: "3.6rem",
                },
                fontWeight: "700",
                mb: { xs: 0.8, sm: 1, md: 1, lg: 0.5, xl: 1.2 },
                lineHeight: isRTL
                  ? { xs: 1.2, md: 1.3 }
                  : { xs: 1.2, md: 1.15 },
                position: "relative",
                fontFamily: "var(--font-plusjakarta)",
                color: "#000000",
                textAlign: isRTL ? "right" : "left",
                width: "100%",
              }}
            >
              {t("hero.title1")}
              <span style={{ color: "#6D50E0" }}>
                {t("hero.titleHighlight1")}
              </span>
              {t("hero.title2")}
              <span style={{ color: "#6D50E0" }}>
                {t("hero.titleHighlight2")}
              </span>
              {t("hero.title3")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#47405A",
                mb: { xs: 4, sm: 3, md: 4 },
                mt: { xs: "3%", sm: "4%", md: "5%" },
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                  lg: "18px",
                  xl: "20px",
                },
                maxWidth: "100%",
                fontWeight: "400",
                fontFamily: isRTL ? "sans-serif" : "var(--font-outfit)",
                lineHeight: { xs: 1.5, md: 1.6 },
                textAlign: isRTL ? "right" : "left",
                width: "100%",
              }}
            >
              {t("hero.desc1")}
            </Typography>

            {/* <Typography
              variant="body1"
              sx={{
                color: "#47405A",
                mb: { xs: 3, sm: 4, md: 4 },
                mt: { xs: "3%", sm: "4%", md: "2.5%" },
                fontSize: {
                  xs: "0.875rem",
                  sm: "1rem",
                  lg: "18px",
                  xl: "20px",
                },
                maxWidth: "100%",
                fontWeight: "400",
                fontFamily: isRTL ? "sans-serif" : "var(--font-outfit)",
                lineHeight: { xs: 1.5, md: 1.6 },
                textAlign: isRTL ? "right" : "left",
                width: "100%",
              }}
            >
              {t("hero.desc2")}
            </Typography> */}

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 1.5, sm: 2 }}
              alignItems={{
                xs: "stretch",
                sm: isRTL ? "flex-end" : "flex-start",
              }}
              justifyContent={isRTL ? "flex-start" : "flex-start"}
              sx={{ mb: { xs: 4, sm: 6, md: 12 }, width: "100%" }}
            >
              <NextLink href="/free-trial-of-ai-recruiting-tool" passHref legacyBehavior>
                <Button
                  component="a"
                  rel="noopener noreferrer"
                  sx={{
                    bgcolor: "#000",
                    color: "#FFFFFF",
                    textTransform: "none",
                    px: { xs: 2.5, sm: 3, md: 3.7 },
                    py: { xs: 1.5, sm: 1.6, md: 1.8 },
                    height: { xs: "48px", sm: "52px", md: "58px" },
                    fontFamily: isRTL ? "sans-serif" : "var(--font-outfit)",
                    fontSize: { xs: "0.8rem", sm: "0.95rem", lg: "1rem" },
                    fontWeight: "500",
                    borderRadius: "28px",
                    boxShadow: "none",
                    transition: "all 0.3s ease-in-out",
                    alignSelf: isRTL ? "flex-start" : "flex-start",
                    "&:hover": {
                      bgcolor: "#6D50E0",
                      color: "#fff",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  {t("hero.cta")}
                </Button>
              </NextLink>
            </Stack>
          </Box>

          {/* Right Content - Image */}
          <Box
            sx={{
              flex: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "flex-start",
              position: "relative",
              overflow: "hidden",
              mr: isRTL ? 0 : { lg: "-16%", xl: "-29.6%" },
              ml: isRTL ? { lg: "-16%", xl: "-66%" } : 0,
              mt: isRTL ? { lg: "-16%", xl: "8%" } : "-4%",
              "@media (min-width: 900px) and (max-width: 1200px)": {
                mr: isRTL ? 0 : "-3%",
                ml: isRTL ? "-3%" : 0,
                objectFit: "contain",
                height: "600px",
              },
              "@media (min-width: 1000px) and (max-width: 1200px)": {
                mr: isRTL ? 0 : "-3%",
                ml: isRTL ? "-30%" : 0,
              },
              "@media (min-width:1100px) and (max-width:1300px)": {
                mr: isRTL ? 0 : "-3%",
                ml: isRTL ? "-30%" : 0,
                height: isRTL ? "40%" : "40%",
              },
              "@media (min-width:1400px) and (max-width:1535px)": {
                maxWidth: isRTL ? "95%" : "95%",
                ml: isRTL ? "-40%" : 0,
                height: isRTL ? "1000px" : "800px",
              },

              "@media (min-width:2000px) and (max-width:2100px)": {
                mr: isRTL ? 0 : "-38%",
                ml: isRTL ? "-75%" : 0,
                height: isRTL ? "1000px" : "800px",
              },
              "@media (min-width:2100px) and (max-width:2350px)": {
                mr: isRTL ? 0 : "-50%",
                ml: isRTL ? "-110%" : 0,
                height: isRTL ? "1000px" : "800px",
              },
              "@media (min-width:2400px) and (max-width:2600px)": {
                mr: isRTL ? 0 : "-56%",
                ml: isRTL ? "-120%" : 0,
                height: isRTL ? "1000px" : "800px",
              },
              width: { md: "auto" },
              height: "800px",
            }}
          >
            <Image
              src={
                isRTL && IMAGES.ARABIC_BG
                  ? IMAGES.ARABIC_BG
                  : IMAGES.HERO_SECTION
              }
              alt="Best AI recruiting tool dashboard showing automated candidate screening and recruitment automation software interface"
              width={1200}
              height={800}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              priority
              fetchPriority="high"
              quality={90}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Main;